<script>
  import { getContext } from "svelte";
  const { data, dateFormat } = $props();

  const { xGet, yScale, custom } = getContext("LayerCake");

  let dateFormatDerived = $derived(dateFormat ? dateFormat : $custom.xFormat);
</script>

<div class="annotation-wrapper" style:top="{$yScale(data.value)}px" style:left="{$xGet(data)}px">
  <p class="annotation-label">{data.key}</p>
  <p class="annotation-date">{dateFormatDerived(data.date)}</p>
  <p class="annotation-value">{$custom.yFormat(data.value)}</p>
</div>

<style>
  .annotation-wrapper {
    position: absolute;
    transform: translate(10px, calc(-100% - 10px));
    text-align: left;
  }
  .annotation-wrapper p {
    color: var(--color-urban-gray-shade-darkest);
    stroke: var(--color-white) solid 2px;
    text-shadow:
      -2px -2px 0 #fff,
      2px -2px 0 #fff,
      -2px 2px 0 #fff,
      2px 2px 0 #fff;
    font-size: 14px !important;
    margin: 0 !important;
    line-height: 18px !important;
  }
  .annotation-label {
    font-weight: var(--font-weight-bold) !important;
  }
  .annotation-value {
    font-weight: var(--font-weight-bold) !important;
  }
  .annotation-date {
    font-style: italic;
  }
</style>
